import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, InputLabel, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import { styled } from '@mui/material/styles';
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
    add, remove, setData
    , setEntity, setNivelLenguaje, setValidations
} from '../redux/memberLanguageLevelSlice'
import DialogYesNo from './DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';

const MemberLanguageLevel = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.memberLanguageLevel.entity)
    const nivelLenguaje = useSelector((state) => state.memberLanguageLevel.nivelLenguaje)
    const defaultEntity = useSelector((state) => state.memberLanguageLevel.defaultEntity)
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    const [numeroDocumentoFocus, setNumeroDocumentoFocus] = useState(null);
    const validate = useSelector((state) => state.memberLanguageLevel.validationActive);
    const dispatch = useDispatch();

    var validation = {
    }

    const setItemValue = (numero, name, value) => {
        dispatch(setData({numero: numero, name: name, value: value}))
    }

    const fecthEntity = async () => {
        const response = await api.get("/Participante/GetsParticipanteNivelLenguajeViewById?idParticipante=" + params.id)
            .catch((err) => {
                console.log("Err: ", err)
            });
        
        if (response.data.data == null || response.data.data.length == 0)
            dispatch(setEntity(defaultEntity));
        else
            dispatch(setEntity(response.data.data));
    }

    const fecthNivelLenguaje = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=111")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setNivelLenguaje(response.data.data));
    }, [])

    useEffect(() => {
        fecthEntity();
        fecthNivelLenguaje();
    }, [])

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    useEffect(() => {
        // validateUniqueDocumentTypes()
        // validateAnyDocumentAtLeast3Digits()
    }, [entity])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deleteEntity = async () => {
        await api.delete("/Participante/DeleteParticipanteNivelLenguaje?idParticipante="
                + params.id + "&numero=" + selectNumero)
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(remove(selectNumero));
    }
    
    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    {"Niveles de Lenguaje (" + (entity != null ? entity.length : 0) + ")"}
                </Box>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly} size="small" aria-label="Agregar Nivel de Lenguaje" style={{height: 10}} onClick={() => {
                    dispatch(add(params.id));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(entity)} */}
                {/* {JSON.stringify(numeroDocumentoExistente)} */}
                <Table size="small">
                    <TableBody>
                        {entity?.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={10} sm={10}>
                                            <Box display="flex" alignItems="center" gap={0}>

                                            </Box>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-niveldelenguaje">Nivel de Lenguaje</InputLabel>
                                                <Select
                                                    //native={!nivelLenguaje.length == 0}
                                                    native
                                                    //defaultValue={0}
                                                    label="Nivel de Lenguaje"
                                                    value={row.idNivelLenguaje}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idNivelLenguaje", event.target.value)
                                                        setItemValue(row.numero, "nivelLenguaje", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idNivelLenguaje',
                                                        id: 'input-niveldelenguaje',
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {nivelLenguaje.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                                {/* <HelperText>
                                                    {validate.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                                                </HelperText>
                                                <HelperText>
                                                    {validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                                                </HelperText> */}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={2} sm={2}>
                                            <IconButton aria-label="delete" size='small' disabled={isReadOnly} onClick={() => {
                                                if (row.id > 0) {
                                                    setSelectId(row.id);
                                                    setSelectNumero(row.numero);
                                                    setOpenDialogDelete(true);
                                                }
                                                else {
                                                    dispatch(remove(row.numero));
                                                }

                                            }}>
                                                <IconDelete />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {/* <FormControl required fullWidth
                    error={
                        (validate.AtLeastOneDocument && validation.AtLeastOneDocument.error)
                        || (validate.OnlyOneTypeDocument && validation.OnlyOneTypeDocument.error)
                        || (validate.DNIWith8Digits && validation.DNIWith8Digits.error)
                        || (validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error)
                        || (validate.DocumentAlReadyExists && validation.DocumentAlReadyExists.error)
                    }>

                    <HelperText>
                        {validate.AtLeastOneDocument && validation.AtLeastOneDocument.error ? validation.AtLeastOneDocument.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate.OnlyOneTypeDocument && validation.OnlyOneTypeDocument.error ? validation.OnlyOneTypeDocument.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate.DocumentAlReadyExists && validation.DocumentAlReadyExists.error ? validation.DocumentAlReadyExists.message : ""}
                    </HelperText>
                </FormControl> */}
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deleteEntity}
                setNo={() => { return }}
                titulo={"Borrar nivel de lenguaje"}
                texto={"Esta seguro de borrar el nivel de lenguaje?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default MemberLanguageLevel;
